import { CartEntryType } from 'utils/cart/types';

export interface TakeoverCartEntry {
  _id?: string | null;
  sanityId?: string | null;
  url?: string | null;
  type?: CartEntryType | string | null;
  isDonation?: boolean | null;
  children?: readonly TakeoverCartEntry[] | null;
}

const PRODUCT_ROOT_TYPES = new Set<string>([
  CartEntryType.combo,
  CartEntryType.item,
  CartEntryType.offerCombo,
  CartEntryType.offerItem,
]);

const hasOwn = (value: object, key: string): boolean =>
  Object.prototype.hasOwnProperty.call(value, key);

const entryMatchesTarget = (
  entry: TakeoverCartEntry,
  targetMenuItemIds: Readonly<Record<string, unknown>>,
  targetIds: readonly string[]
): boolean => {
  if (entry.isDonation || !entry.type || !PRODUCT_ROOT_TYPES.has(entry.type)) {
    return false;
  }

  if (entry.sanityId && hasOwn(targetMenuItemIds, entry.sanityId)) {
    return true;
  }

  if (entry._id && hasOwn(targetMenuItemIds, entry._id)) {
    return true;
  }

  return Boolean(entry.url && targetIds.some(targetId => entry.url?.includes(targetId)));
};

/**
 * Whether a live or submitted cart contains at least one product targeted by
 * the active takeover. Non-product entries and nested product details do not
 * independently control cart-level takeover eligibility.
 */
export const doesCartContainTakeoverTarget = (
  cartEntries: readonly TakeoverCartEntry[] | null | undefined,
  targetMenuItemIds: Readonly<Record<string, unknown>> | null | undefined
): boolean => {
  if (!cartEntries?.length || !targetMenuItemIds) {
    return false;
  }

  const targetIds = Object.keys(targetMenuItemIds);
  if (!targetIds.length) {
    return false;
  }

  return cartEntries.some(entry => entryMatchesTarget(entry, targetMenuItemIds, targetIds));
};
